import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const SuggestionFill16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 10.3311C11.9945 9.46657 13 7.85071 13 6C13 3.23858 10.7614 1 8 1C5.23858 1 3 3.23858 3 6C3 7.85071 4.0055 9.46657 5.5 10.3311V11.5C5.5 12.0523 5.94772 12.5 6.5 12.5H9.5C10.0523 12.5 10.5 12.0523 10.5 11.5V10.3311ZM5.5 14.25C5.5 13.8358 5.83579 13.5 6.25 13.5H9.75C10.1642 13.5 10.5 13.8358 10.5 14.25C10.5 14.6642 10.1642 15 9.75 15H6.25C5.83579 15 5.5 14.6642 5.5 14.25Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
